module.exports = __webpack_public_path__ + "img/fig22.7af99463.jpg";